import Model from '../Model'
import moment from "moment";

export default class EarlyWarningNotice extends Model {
    getFormAttributes() {
        return this;
    }

    static parseAttributes(attributes = {}) {
        return attributes
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formatted_date = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [this.givenByName, this.formattedDate,]
        this.tokens = tokens.join('|').toLowerCase();
    }

    static async find(packageReference, id) {
        const data = await Http.get(route('api.v2.project-delivery.early-warning-notice', [packageReference, id]))
        return this.make(data);
    }

    static async list(packageReference = null) {
        const params = {}
        const data = await Http.get(route('api.v2.project-delivery.early-warning-notice.list', [packageReference]), {params})
        return this.make(data)
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.project-delivery.early-warning-notice.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.project-delivery.early-warning-notice', [packageReference, id]))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v2.project-delivery.early-warning-notice.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
    }

    async delete() {
        await Http.delete(route('api.v2.project-delivery.early-warning-notice.delete', [this.packageReference, this.id]))
    }
}
